import { useEffect, useState } from 'react';
import './Blogs.scss';
import { Link } from 'react-router-dom';
import { apiGet } from '../api/apiClient';

function formatDate(isoString) {
  if (!isoString) return '';
  const date = new Date(isoString);
  return new Intl.DateTimeFormat('pl-PL', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  }).format(date);
}

export function Blogs() {
  const [blogs, setBlogs] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    setLoading(true);
    apiGet('/blog-list.php')
      .then((data) => {
        setBlogs(data);
        setLoading(false);
      })
      .catch((err) => {
        setError('Nie udało się załadować wpisów.');
        setLoading(false);
      });
  }, []);

  if (loading) {
    return (
      <article className="blogs-article blogs-article--state">
        <p className="blogs-status">Ładowanie&hellip;</p>
      </article>
    );
  }

  if (error) {
    return (
      <article className="blogs-article blogs-article--state">
        <p className="blogs-status blogs-status--error">{error}</p>
      </article>
    );
  }

  if (!blogs || blogs.length === 0) {
    return (
      <article className="blogs-article blogs-article--state">
        <p className="blogs-status">Brak opublikowanych wpisów.</p>
      </article>
    );
  }

  return (
    <article className="blogs-article">
      {blogs.map((blog) => (
        <Link key={blog.id} to={`/blog/${blog.slug}`}>
          <div className="blog-list-item">
            <div className="image-container">
              {blog.cover_image_url ? (
                <div
                  className="image"
                  style={{ backgroundImage: `url(${blog.cover_image_url})` }}
                  role="img"
                  aria-label={blog.cover_image_alt || blog.title}
                />
              ) : (
                <div className="image image--placeholder" />
              )}
            </div>
            <div className="content">
              <h2>{blog.title}</h2>
              {blog.excerpt && <p className="excerpt">{blog.excerpt}</p>}
              <div className="date">{formatDate(blog.published_at)}</div>
            </div>
          </div>
        </Link>
      ))}
    </article>
  );
}
